import { z } from 'zod';
import { LocationConfigurationSchema as LocationSchema } from '@/modules/location/domain/LocationConfigurationSchema.ts';
import { LocationTypeSchema } from '@/modules/location/domain/LocationSchema.ts';

export const LocationConfigurationSchema = z.object({
    ...LocationSchema.shape,
    type: LocationTypeSchema,
});

export type LocationConfiguration = z.infer<typeof LocationConfigurationSchema>;
